import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useBackendAuth } from '../contexts/BackendAuthContext';

const BackendLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, loading } = useBackendAuth();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Log current path for debugging
  useEffect(() => {
    console.log('Backend Login Page - Current path:', location.pathname);
    console.log('Firebase auth status:', currentUser ? 'logged in' : 'not logged in');
  }, [location.pathname, currentUser]);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('Username and password are required');
      return;
    }

    try {
      const success = await login(username, password);
      if (success) {
        navigate('/backend-dashboard');
      }
    } catch (err) {
      console.error('Login error:', err);

      // Check for connection errors
      if (err.message && err.message.includes('ERR_CONNECTION_REFUSED')) {
        setError(
          'Connection to backend server failed. The backend server may not be running or might be unavailable.'
        );
      } else if (err.message && err.message.includes('NetworkError')) {
        setError('Network error. Please check your internet connection.');
      } else if (err.status === 401) {
        setError('Invalid username or password. Please try again.');
      } else {
        setError(`Login failed: ${err.message || 'Unknown error'}`);
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      {/* <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Backend Admin Login
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            This is a separate authentication system for backend testing
          </p>
          <div className="mt-3 text-center">
            <Link to="/login" className="text-blue-500 hover:text-blue-700">
              Return to Firebase Auth Login
            </Link>
          </div>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="username" className="sr-only">
                Username
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Username (try 'admin' or 'developer')"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Password (try 'admin123' or 'dev123')"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <div className="text-red-500 text-sm mt-2">
              {error}
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-300"
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </div>
          
          <div className="text-center text-sm">
            <p className="text-gray-600 mt-4">
              Test Credentials:
            </p>
            <p className="text-gray-600">
              Username: admin or developer
            </p>
            <p className="text-gray-600">
              Password: admin123 or dev123
            </p>
          </div>
        </form>
      </div> */}
    </div>
  );
};

export default BackendLoginPage;
